/**
 * Created by lu on 2018/4/16.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../../../view/tab/TabWrap'),
    slot: {
        content: ['html', [{
            $name:'orderScreen',
            $type: require('./OrderScreen'),
            $model: 'orderScreen'
        },{
            $type: require('./OrderNav'),
            $model: 'orderNav'
        },{
            $name:'orderList',
            $type:require('../../../view/pagination/PaginationList'),
            $model:'orderList'
        }]]
    },
    method:{
        init:function () {
            var self = this;

            //点击搜索
            this.$('orderScreen').$().on('click', '.screen-order', function () {   //点击订单搜索
                var model = self.getModel();
                model.set('requireScreenOrder', new Date());
            });

            //立即付款
            this.$('orderList').$().on('click','.to-play',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireToPay', index);
            });

            //取消订单
            this.$('orderList').$().on('click','.to-cancel',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireCancelOrder', index);
            });

            //删除订单
            this.$('orderList').$().on('click','.to-delete',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireDeleteOrder', index);
            });

            //确认收货
            this.$('orderList').$().on('click','.to-confirm',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireConfirmGoodsOrder', index);
            });

            //申请退货
            this.$('orderList').$().on('click','.after-sales',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireReturnGoodsOrder', index);
            });

            //查看物流
            this.$('orderList').$().on('click','.to-see',function () {
                var model = self.getModel();
                var index = $(this).parents('.order-list').attr('data-list-index');
                model.set('requireSeeLogistics', index);
            });
        }
    }
});


// bar: ['html', {
//     $name:'recycle-bin',
//     'class': 'recycle-bin',
//     $html: [{
//         'class': 'iconfont icon-huishouzhan',
//         tag: 'span'
//     }, {
//         tag: 'span',
//         $text: nb.bind('recycleText')//'回收站'
//     }]
// }],
// //点击回收站
// this.$('recycle-bin').on('click',function () {
//     self.getModel().set('requireRecycle',new Date());
// });


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/view/Content.js
// module id = 674
// module chunks = 3